import { render, staticRenderFns } from "./actualizaSucursal.vue?vue&type=template&id=d53ab47e&"
import script from "./actualizaSucursal.vue?vue&type=script&lang=js&"
export * from "./actualizaSucursal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports